import { maxCreditCardAmount } from 'data/mock-data';

const mock = () => ({
  data: { maxCreditCardAmount },
});

export default mock;
